// Family collaboration UI (section 30). Owner invites people, assigns a role and which
// modules they can help with. Secret Santa is never shared.
export const extra10 = {
  pt: {
    "nav.family": "Colaboração Familiar",
    "family.title": "Colaboração Familiar",
    "family.subtitle": "Convide sua família para ajudar a organizar o Natal — cada pessoa com seu papel.",
    "family.invite_title": "Convidar alguém",
    "family.name": "Nome", "family.email": "E-mail",
    "family.name_ph": "Ex.: Jéssica", "family.email_ph": "email@exemplo.com",
    "family.role": "Papel", "family.scope": "Pode ajudar com", "family.scope_hint": "Escolha os módulos que essa pessoa poderá ver e colaborar.",
    "family.send": "Enviar convite", "family.sending": "Enviando...",
    "family.list_title": "Sua família",
    "family.empty": "Ninguém convidado ainda. Comece adicionando alguém acima.",
    "family.status_invited": "Convidado",
    "family.remove": "Remover",
    "family.ss_note": "🔒 As informações do Amigo Oculto nunca são compartilhadas com colaboradores.",
    "family.no_plan": "Crie o seu Natal primeiro para poder convidar a sua família.",
    "family.create": "Criar Meu Natal",
    "family.added": "Convite adicionado!",
    "family.removed": "Colaborador removido.",
    "family.role.helper": "Ajudante geral", "family.role.desserts": "Sobremesas", "family.role.drinks": "Bebidas",
    "family.role.decoration": "Decoração", "family.role.gifts": "Presentes",
    "family.tasks_title": "Tarefas compartilhadas", "family.add_task": "Adicionar tarefa",
    "family.task_ph": "Ex.: Comprar bebidas", "family.responsible": "Responsável", "family.unassigned": "Sem responsável",
    "family.me": "Eu", "family.due": "Prazo", "family.status": "Status",
    "family.status.pending": "Pendente", "family.status.doing": "Em andamento", "family.status.done": "Concluído",
    "family.no_tasks": "Nenhuma tarefa ainda. Adicione a primeira acima.", "family.task_added": "Tarefa adicionada!",
  },
  en: {
    "nav.family": "Family Collaboration",
    "family.title": "Family Collaboration",
    "family.subtitle": "Invite your family to help organize Christmas — each person with their own role.",
    "family.invite_title": "Invite someone",
    "family.name": "Name", "family.email": "Email",
    "family.name_ph": "e.g. Jessica", "family.email_ph": "email@example.com",
    "family.role": "Role", "family.scope": "Can help with", "family.scope_hint": "Choose the modules this person can see and collaborate on.",
    "family.send": "Send invite", "family.sending": "Sending...",
    "family.list_title": "Your family",
    "family.empty": "No one invited yet. Start by adding someone above.",
    "family.status_invited": "Invited",
    "family.remove": "Remove",
    "family.ss_note": "🔒 Secret Santa information is never shared with collaborators.",
    "family.no_plan": "Create your Christmas first to invite your family.",
    "family.create": "Create My Christmas",
    "family.added": "Invite added!",
    "family.removed": "Collaborator removed.",
    "family.role.helper": "General helper", "family.role.desserts": "Desserts", "family.role.drinks": "Drinks",
    "family.role.decoration": "Decoration", "family.role.gifts": "Gifts",
    "family.tasks_title": "Shared tasks", "family.add_task": "Add task",
    "family.task_ph": "e.g. Buy drinks", "family.responsible": "Responsible", "family.unassigned": "Unassigned",
    "family.me": "Me", "family.due": "Due", "family.status": "Status",
    "family.status.pending": "Pending", "family.status.doing": "In progress", "family.status.done": "Done",
    "family.no_tasks": "No tasks yet. Add the first one above.", "family.task_added": "Task added!",
  },
  es: {
    "nav.family": "Colaboración Familiar",
    "family.title": "Colaboración Familiar",
    "family.subtitle": "Invita a tu familia a ayudar a organizar la Navidad — cada persona con su papel.",
    "family.invite_title": "Invitar a alguien",
    "family.name": "Nombre", "family.email": "Correo",
    "family.name_ph": "Ej.: Jéssica", "family.email_ph": "correo@ejemplo.com",
    "family.role": "Papel", "family.scope": "Puede ayudar con", "family.scope_hint": "Elige los módulos que esta persona podrá ver y colaborar.",
    "family.send": "Enviar invitación", "family.sending": "Enviando...",
    "family.list_title": "Tu familia",
    "family.empty": "Nadie invitado aún. Empieza agregando a alguien arriba.",
    "family.status_invited": "Invitado",
    "family.remove": "Quitar",
    "family.ss_note": "🔒 La información del amigo invisible nunca se comparte con colaboradores.",
    "family.no_plan": "Crea tu Navidad primero para invitar a tu familia.",
    "family.create": "Crear Mi Navidad",
    "family.added": "¡Invitación agregada!",
    "family.removed": "Colaborador eliminado.",
    "family.role.helper": "Ayudante general", "family.role.desserts": "Postres", "family.role.drinks": "Bebidas",
    "family.role.decoration": "Decoración", "family.role.gifts": "Regalos",
    "family.tasks_title": "Tareas compartidas", "family.add_task": "Añadir tarea",
    "family.task_ph": "Ej.: Comprar bebidas", "family.responsible": "Responsable", "family.unassigned": "Sin responsable",
    "family.me": "Yo", "family.due": "Fecha límite", "family.status": "Estado",
    "family.status.pending": "Pendiente", "family.status.doing": "En curso", "family.status.done": "Hecho",
    "family.no_tasks": "Aún no hay tareas. Añade la primera arriba.", "family.task_added": "¡Tarea añadida!",
  },
  fr: {
    "nav.family": "Collaboration Familiale",
    "family.title": "Collaboration Familiale",
    "family.subtitle": "Invitez votre famille à aider à organiser Noël — chacun avec son rôle.",
    "family.invite_title": "Inviter quelqu'un",
    "family.name": "Nom", "family.email": "E-mail",
    "family.name_ph": "Ex. : Jessica", "family.email_ph": "email@exemple.com",
    "family.role": "Rôle", "family.scope": "Peut aider avec", "family.scope_hint": "Choisissez les modules que cette personne pourra voir et sur lesquels collaborer.",
    "family.send": "Envoyer l'invitation", "family.sending": "Envoi...",
    "family.list_title": "Votre famille",
    "family.empty": "Personne d'invité pour l'instant. Commencez par ajouter quelqu'un ci-dessus.",
    "family.status_invited": "Invité",
    "family.remove": "Retirer",
    "family.ss_note": "🔒 Les informations du Père Noël secret ne sont jamais partagées avec les collaborateurs.",
    "family.no_plan": "Créez d'abord votre Noël pour inviter votre famille.",
    "family.create": "Créer Mon Noël",
    "family.added": "Invitation ajoutée !",
    "family.removed": "Collaborateur retiré.",
    "family.role.helper": "Aide générale", "family.role.desserts": "Desserts", "family.role.drinks": "Boissons",
    "family.role.decoration": "Décoration", "family.role.gifts": "Cadeaux",
    "family.tasks_title": "Tâches partagées", "family.add_task": "Ajouter une tâche",
    "family.task_ph": "Ex. : Acheter les boissons", "family.responsible": "Responsable", "family.unassigned": "Non assigné",
    "family.me": "Moi", "family.due": "Échéance", "family.status": "Statut",
    "family.status.pending": "En attente", "family.status.doing": "En cours", "family.status.done": "Terminé",
    "family.no_tasks": "Aucune tâche pour l'instant. Ajoutez la première ci-dessus.", "family.task_added": "Tâche ajoutée !",
  },
  it: {
    "nav.family": "Collaborazione Familiare",
    "family.title": "Collaborazione Familiare",
    "family.subtitle": "Invita la tua famiglia ad aiutare a organizzare il Natale — ognuno con il suo ruolo.",
    "family.invite_title": "Invita qualcuno",
    "family.name": "Nome", "family.email": "E-mail",
    "family.name_ph": "Es.: Jessica", "family.email_ph": "email@esempio.com",
    "family.role": "Ruolo", "family.scope": "Può aiutare con", "family.scope_hint": "Scegli i moduli che questa persona potrà vedere e su cui collaborare.",
    "family.send": "Invia invito", "family.sending": "Invio...",
    "family.list_title": "La tua famiglia",
    "family.empty": "Nessuno invitato ancora. Inizia aggiungendo qualcuno qui sopra.",
    "family.status_invited": "Invitato",
    "family.remove": "Rimuovi",
    "family.ss_note": "🔒 Le informazioni dell'amico segreto non vengono mai condivise con i collaboratori.",
    "family.no_plan": "Crea prima il tuo Natale per invitare la tua famiglia.",
    "family.create": "Crea il mio Natale",
    "family.added": "Invito aggiunto!",
    "family.removed": "Collaboratore rimosso.",
    "family.role.helper": "Aiutante generale", "family.role.desserts": "Dolci", "family.role.drinks": "Bevande",
    "family.role.decoration": "Decorazione", "family.role.gifts": "Regali",
    "family.tasks_title": "Attività condivise", "family.add_task": "Aggiungi attività",
    "family.task_ph": "Es.: Comprare le bevande", "family.responsible": "Responsabile", "family.unassigned": "Non assegnato",
    "family.me": "Io", "family.due": "Scadenza", "family.status": "Stato",
    "family.status.pending": "In sospeso", "family.status.doing": "In corso", "family.status.done": "Fatto",
    "family.no_tasks": "Nessuna attività ancora. Aggiungi la prima qui sopra.", "family.task_added": "Attività aggiunta!",
  },
};
